import React, { useEffect, useState } from 'react'


import { Typography, Button, Paper } from '@material-ui/core';
import { useNavigate } from "react-router"
import { makeStyles } from '@material-ui/styles';

import { useLocation } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import Carousel from 'react-material-ui-carousel'
import moment from 'moment/moment';

const Styles = makeStyles({

    backBtn: {
        display: "block",
        width: "100%",
        maxWidth: 360,
        margin: "0 auto 16px auto",
        padding: "14px 24px",
        borderRadius: 12,
        textTransform: "uppercase",
        fontWeight: 700,
        fontSize: 15,
        color: "#ffffff",
        letterSpacing: 1,
        background: "linear-gradient(180deg, #990000 0%, #660000 100%)",
        border: "1px solid rgba(255, 0, 0, 0.3)",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.4)",
        cursor: "pointer",
        transition: "transform 0.2s ease, filter 0.2s ease",
        outline: "none",
        "&:active": {
            transform: "scale(0.98)",
            filter: "brightness(1.2)"
        }
    },
    card: {
        width: "100%",
        maxWidth: 360,
        margin: "0 auto 24px auto",
        backgroundColor: "rgba(20, 24, 33, 0.65)",
        border: "1px solid rgba(255, 255, 255, 0.12)",
        borderRadius: 16,
        padding: 16,
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    cardTitle: {
        width: "100%",
        color: "#ffffff",
        fontWeight: 800,
        fontStyle: "italic",
        textTransform: "uppercase",
        letterSpacing: 1,
        fontSize: 18,
        textAlign: "center",
        textShadow: "2px 2px 6px rgba(0, 0, 0, 0.9)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
        paddingBottom: 10,
        marginBottom: 12
    },
    row: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "12px 0",
        borderBottom: "1px solid rgba(255, 255, 255, 0.06)"
    },
    rowOro: {
        background: "rgba(212, 175, 55, 0.18)",
        borderRadius: 8,
        paddingLeft: 8,
        paddingRight: 8
    },
    rowPlata: {
        background: "rgba(192, 192, 192, 0.14)",
        borderRadius: 8,
        paddingLeft: 8,
        paddingRight: 8
    },
    rowDestacado: {
        boxShadow: "0 0 0 1px rgba(57, 255, 20, 0.5)",
        backgroundColor: "rgba(57, 255, 20, 0.08)"
    },
    puesto: {
        width: 44,
        height: 44,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        fontWeight: 700,
        fontSize: 16
    },
    puestoOro: {
        backgroundColor: "rgba(212, 175, 55, 0.18)",
        border: "1px solid rgba(212, 175, 55, 0.7)",
        color: "#ffd700",
        textShadow: "0 0 8px rgba(255, 215, 0, 0.6)"
    },
    puestoPlata: {
        backgroundColor: "rgba(192, 192, 192, 0.18)",
        border: "1px solid rgba(192, 192, 192, 0.7)",
        color: "#e0e0e0",
        textShadow: "0 0 8px rgba(192, 192, 192, 0.6)"
    },
    nombre: {
        color: "#ffffff",
        fontSize: 15,
        fontWeight: 600,
        textTransform: "capitalize",
        paddingLeft: 12,
        boxSizing: "border-box",
        flex: 1
    },
    bracketScroll: {
        width: "100%",
        overflowX: "auto",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
        maxWidth: "100%"
    },
    llaves: {
        height: "200vh",
        width: "350vh",
        color: "white",
        display: "flex",
        flexDirection: "row",
        paddingTop: "40px",
        justifyContent: "left",
        "@media (max-width: 800px)": {
            width: "200vh",
            height: "500vh"
        }
    },
})

const EliminacionDirecta = ({ llave, ancho, compId }) => {

    const classes = Styles()
    const { state } = useLocation();
    const navigate = useNavigate()
    const [Encuentros, setEncuentros] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [anio, setAnio] = useState("2020");
    const [cantDias, setCantDias] = useState(1);
    const [loading, setLoading] = useState(true);

    ancho("350vh")
    useEffect(() => {
        const m = () => {
            let rm = llave.sort((a, b) => b.ronda - a.ronda)
            let rmaximo = rm[0].ronda

            let vertical = 0
            let horizontal = 0


            if (rmaximo <= 3) { vertical = "200vh"; horizontal = "350vh" }
            if (rmaximo == 4) { vertical = "250vh"; horizontal = "430vh" }
            if (rmaximo == 5) { vertical = "300vh"; horizontal = "550vh" }


         //   let datos = { width: ancho, height: alto }
          //  ancho(datos)
        }
       // m()
    }, [])

    //------cantidad de match
    let altoNombre = 40
    let espaciado = altoNombre / 2
    let MargenIzquierdo = 0
    let MargenInferior = 40 * 3
    let largoPosicion = 300;

   


    const posicionResultado = (llave) => {

        let primero = {};
        let segundo = {};

        llave.map((x) => {
            if (x.next == 0) {
                if (x.resultado == 1) {
                    primero = { ...x }
                }
                else if (x.resultado == 0) { segundo = { ...x } }
            }
        })

        const destacadoPrimero = compId != null && primero.competidor_id == compId
        const destacadoSegundo = compId != null && segundo.competidor_id == compId

        return (
            <div className={classes.card}>
                <Typography className={classes.cardTitle}>Puestos</Typography>

                <div className={`${classes.row} ${classes.rowOro} ${destacadoPrimero ? classes.rowDestacado : ""}`}>
                    <div className={`${classes.puesto} ${classes.puestoOro}`}>1º</div>
                    <Typography className={classes.nombre}>
                        {primero.nombre ? primero.nombre + " " + primero.apellido : "- -"}</Typography>
                </div>

                <div className={`${classes.row} ${classes.rowPlata} ${destacadoSegundo ? classes.rowDestacado : ""}`}>
                    <div className={`${classes.puesto} ${classes.puestoPlata}`}>2º</div>
                    <Typography className={classes.nombre}>
                        {segundo.nombre ? segundo.nombre + " " + segundo.apellido : "- -"}</Typography>
                </div>
            </div>
        )
    }

    const PosicionLLave = (datos, ronda) => {


        let margenL = 30;
        let margenB = 0
        let tamañollave = 40
        let margenT = 100;
        let color = "white"
        let compe = datos.competidor_id > 0 ? datos.nombre + " " + datos.apellido : null;
        let bordeInferior = "solid"
        if (datos.posicion % 2 !== 1) {
            if (ronda == 1) { margenL = margenL; margenB = espaciado; margenT = 0; }
            if (ronda == 2) { margenL = margenL; margenB = espaciado * 3; tamañollave = espaciado * 5 }
            if (ronda == 3) { margenL = margenL; margenB = espaciado * 8; tamañollave = espaciado * 10 }
            if (ronda == 4) { margenL = margenL; margenB = espaciado * 17; tamañollave = espaciado * 21 }
            if (ronda == 5) { margenL = margenL; margenB = espaciado * 16; tamañollave = espaciado * 42 }

            bordeInferior = "solid"
        } else { bordeInferior = "none" }
     
        return (

            <div style={{paddingLeft:"10px", alignItems: "flex-end", borderBottomStyle: "solid", borderRightStyle: bordeInferior, display: "flex", flexDirection: "row", marginBottom: margenB, width: largoPosicion, height: tamañollave }}>


                <Typography


                    style={{ textAlign: "initial", paddingLeft: 10, textTransform: "capitalize" }}
                > {compe !== null ? compe : "-  -"}

                </Typography>
            </div>

        )
    }

    return (

        <div style={{ height: "auto", width: "100%", color: "white" }}  >

            <Button className={classes.backBtn} onClick={() => navigate(-1)}>
                Volver
            </Button>

            {llave.length > 0 ? posicionResultado(llave) : null}

            <div className={classes.bracketScroll}>
            <div className={classes.llaves}     >

                <div  >
                    {llave.map((x) => {
                        if (x.ronda == 1) {
                            return (PosicionLLave(x, 1))
                        }
                    })}
                </div>

                <div style={{ paddingTop: espaciado * 1 }}>
                    {llave.map((x) => {
                        if (x.ronda == 2) {
                            return (PosicionLLave(x, 2))
                        }

                    })}
                </div>

                <div style={{ paddingTop: espaciado * 3.5 }}>
                    {llave.map((x) => {
                        if (x.ronda == 3) {
                            return (PosicionLLave(x, 3))
                        }
                    })}
                </div>

                <div style={{ paddingTop: espaciado * 8 }}>
                    {llave.map((x) => {
                        if (x.ronda == 4) {
                            return (PosicionLLave(x, 4))
                        }
                    })}


                </div>

                <div style={{ paddingTop: espaciado * 16 }}>
                    {llave.map((x) => {

                        if (x.ronda == 5) {
                            return (PosicionLLave(x, 5))
                        }


                    })}
                </div>

            </div>
            </div>






            {loading === true ? <>


            </>
                : <>
                    <CircularProgress />
                </>
            }


        </div>
    );
}

export default EliminacionDirecta;